import { RemoteConfig } from '@qvs/core';
import { Value } from '@angular/fire/remote-config';
import { DateUtils } from '~/shared/utils/date.utils';

export class RemoteConfigMapper {
  public static readonly fromFirebaseRemoteConfig = (firebaseRemoteConfig: Record<string, Value>): RemoteConfig | undefined =>
    firebaseRemoteConfig
      ? {
          beforeMaintenanceStartDate: DateUtils.new(firebaseRemoteConfig?.before_maintenance_start_date?.asString()).toDate(),
          beforeMaintenanceEndDate: DateUtils.new(firebaseRemoteConfig?.before_maintenance_end_date?.asString()).toDate(),
          beforeMaintenanceMessage: firebaseRemoteConfig?.before_maintenance_message?.asString(),
          maintenanceStartDate: DateUtils.new(firebaseRemoteConfig?.maintenance_start_date?.asString()).toDate(),
          maintenanceEndDate: DateUtils.new(firebaseRemoteConfig?.maintenance_end_date?.asString()).toDate(),
          maintenanceMessage: firebaseRemoteConfig?.maintenance_message?.asString(),
          currentAppVersion: firebaseRemoteConfig?.current_app_version?.asString(),
          minAppVersion: firebaseRemoteConfig?.min_app_version?.asString(),
          cgeNewsToken: firebaseRemoteConfig?.cge_news_token?.asString()
        }
      : undefined;
}
